module.exports = __webpack_public_path__ + "static/orimi-d38d7e9164a3ee12f985e95fd715d061.png";